module.exports = __webpack_public_path__ + "static/media/Galano_Grotesque_Bold.1a59f3fb.otf";